import { Component, OnInit, AfterViewInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ReactiveFormsModule, FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from "@angular/forms";
import { CityService } from '../../services/city.service';
@Component({
  selector: "contactUs",
  templateUrl: './contactUs.component.html',
  styleUrls: ["./contactUs.component.scss"]
})
export class ContactUsComponent implements OnInit {

  showForm: boolean = true;

  contactUsForm: FormGroup;
  get FullName() { return this.contactUsForm.get('FullName'); }
  get LocalGovernment() { return this.contactUsForm.get('LocalGovernment'); }
  get Email() { return this.contactUsForm.get('Email'); }
  get Job() { return this.contactUsForm.get('Job'); }
  get Phone() { return this.contactUsForm.get('Phone'); }
  get Subject() { return this.contactUsForm.get('Subject'); }
  get IsConfirmed() { return this.contactUsForm.get('IsConfirmed'); }
  get Body() { return this.contactUsForm.get('v'); }
  /*FullName: FormControl;
  LoaclGoverment: FormControl;
  Email: FormControl;
  Job: FormControl;
  Phone: FormControl;
  Subject:FormControl;
  IsConfirmed:FormControl;*/

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private cityService: CityService) { }


  ngOnInit() {

    this.contactUsForm = this.fb.group({
      FullName: ['', Validators.required],
      Email: ['', [Validators.required,
      Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      LocalGovernment: [''],
      Job: [],
      Phone: [''],
      Subject: ['', Validators.required],
      Body: [],
      IsConfirmed: ['', Validators.requiredTrue]
    });
  }

  public onFormSubmit() {
    if (this.contactUsForm.valid) {
      this.showForm = false;
      this.cityService.saveForm(this.contactUsForm.value)
        .subscribe(data => { setInterval (() => {
          this.activeModal.close()
        }, 500) });

    }

  }
}


// WEBPACK FOOTER //
// ./src/app/component/contactus/contactus.component.ts